document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-product-thumb]');
  if (!thumb) return;
  const mainImage = document.querySelector('[data-product-main-image]');
  if (!mainImage) return;
  const newSrc = thumb.dataset.imageSrc;
  const newAlt = thumb.dataset.imageAlt || '';
  if (newSrc) {
    mainImage.src = newSrc;
    mainImage.alt = newAlt;
  }
});

// Cierra los menús desplegables al clicar fuera, al pulsar Escape o al abrir otro.
document.addEventListener('toggle', (event) => {
  const opened = event.target;
  if (!(opened instanceof HTMLDetailsElement) || !opened.matches('details.nav-dropdown') || !opened.open) return;

  document.querySelectorAll('details.nav-dropdown[open]').forEach((details) => {
    if (details !== opened && !details.contains(opened)) details.removeAttribute('open');
  });
}, true);

document.addEventListener('click', (event) => {
  document.querySelectorAll('details.nav-dropdown[open]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('details.nav-dropdown[open]').forEach((details) => details.removeAttribute('open'));
});
